import myApi from '@/util/api'

export function getTaskAppointments() {

    return myApi.getAll('TaskAppointment/GetTaskAppointments')
}
export function getTaskAppointment(data) {

    return myApi.getItem(data, "TaskAppointment/GetData")
}
export function createTaskAppointment(data) {
    return myApi.create(data, "TaskAppointment/InsertTaskAppointment")
}

export function updateTaskAppointment(data) {

    return myApi.update(data.taskAppointmentID, data, "TaskAppointment/UpdateTaskAppointment")
}
export function deleteTaskAppointment(data) {

    return myApi.delete(data.taskAppointmentID, 'TaskAppointment/DeleteTaskAppointment')
}
export function getTaskAppointmentsByID(id, userId) {

    return myApi.getByuserId(id, userId, 'TaskAppointment/GetTaskAppointmentsByID')
}


// WEBPACK FOOTER //
// ./src/api/taskAppointment.js